<div class="igv">
  <div class="igv_top-bar">
    <div class="igv-location-label igv-flex-one">
      <span class="igv-pre-text igv-text-align">Displayed range: </span>
      <span class="igv-text-align">Chr{{locus}}</span>
    </div>
    <button id="igv_reset_view_btn" class="btn btn-link igv-margin-right-left" (click)="resetView()">Reset View</button>
    <div class="igv-display-flex-end igv-flex-one">
      <button id="igv_select_tracks_btn" class="btn btn-link" (click)="op.toggle($event,opTarget)" #opTarget>+/- Select tracks </button>
    </div>
  </div>
  <div class="igv_divider igv-margin-top-bottom"></div>
  <div style="margin-top: 2em; width: 100% ; height: 100%;">
    <div #igvDiv #goToInput></div>
    <gen-overlay-loader *ngIf="loading" [showOverlay]="false"></gen-overlay-loader>
  </div>
</div>

<p-overlayPanel #op appendTo="body">
  <div *ngFor="let track of availableTracks" class="igv-checkbox-container">
    <p-checkbox id="{{track.label}}-checkbox"  name={{track.name}} label="{{track.label}}" checkboxIcon="icon__Checkmark1"
                 binary="true" [(ngModel)]="track.checked" (onChange)="tracksChanged(track)"></p-checkbox>
  </div>
</p-overlayPanel>

<p-dialog class="igv-popup-wrapper" header="Details" [draggable]="false" [(visible)]="displayPopup" [modal]="true" [responsive]="true" [style]="{width: '600px'}">
  <div  class="igv-popup-content-details">
    <div *ngFor="let item of popupContent">
        <span class="dynamic-modal-content Auto_Popup_Text" *ngIf="!!item['name'] ; else oneItemBlock">{{item.name}} - {{item.value}}</span>
        <ng-template #oneItemBlock>
          <span class="dynamic-modal-content Auto_Popup_Text" *ngIf="item !== '<hr/>' ; else noItemBlock">{{item}}</span>
        </ng-template>
        <ng-template #noItemBlock><br></ng-template>
    </div>
  </div>
</p-dialog>


